import { observable, action, computed, makeObservable } from 'mobx';
import { LocalStorage } from '../bridges/local-storage.bridge';

class AnalyticsStore {
  @observable binomID = null;

  @observable authToken = null;

  @action setAndSaveBinomID = (id) => {
    this.binomID = id;
    LocalStorage.set(`session-${this.authToken}-binom`, id);
  };

  constructor() {
    makeObservable(this);
  }

  @computed get getBinomID() {
    return this.binomID || LocalStorage.get(`session-${this.authToken}-binom`);
  }

  @action setAuthToken(token) {
    this.authToken = token;
  }
}

const analyticsStore = new AnalyticsStore();

export default analyticsStore;
